import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import NotExist from "../../common/NotExist";
import {isIterableArray} from "../../../utils/common";
import {getSnapShot} from "../../snapshot/action";
import OSListItem from "./OSListItem";
import ListSkeleton from "../../common/ListSkeleton";
import {checkErrorResponse} from "../../../helpers/errorCheck";


const Snapshot = () => {
    const dispatch = useDispatch();
    const {snapShotList} = useSelector(state => state.snapShot);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    useEffect(() => {
        getSnapShot().then(response => {
            if (response) {
                if (response.request.status === 200) {
                    dispatch(response);
                }
            }
        }).catch(err => {
            checkErrorResponse(err);
        })
    }, [])

    useEffect(() => {
        if (snapShotList) {
            setSkeletonLoader(true);
        }
    }, [snapShotList]);

    return (
        <div className='snapshot_wrapper'>
            <ListSkeleton colNum={3} itemNum={8} height={120} loading={skeletonLoader}>
                {isIterableArray(snapShotList) ?
                    <OSListItem atr={'vs_id'}
                                osData={snapShotList}
                                loader={false}
                                img={'https://s3.server24.kr/panel/img/os/Snapshot.svg'}
                                name='vs_description'
                                date='vs_date_created'
                                osType='snapshot'/>

                    :
                    <NotExist type={'list'} height={400} text={'스냅샷이 존재하지 않습니다.'}/>
                }
            </ListSkeleton>
        </div>
    )
}

export default Snapshot;
